import axios from '../../axios.js'

function params(payload = {}) {
  const result = {}
  if (payload.from) result.from = payload.from
  if (payload.to) result.to = payload.to
  if (payload.status) result.status = payload.status
  return result
}

export default {
  async fetchSummary(context, payload = {}) {
    const response = await axios.get('/peppol-submissions/pa-report/summary', {
      params: params(payload),
    })
    return response.data
  },

  async fetchMonthlySummary(context, payload = {}) {
    const response = await axios.get('/peppol-submissions/pa-report/monthly-summary', {
      params: params(payload),
    })
    return response.data
  },

  async fetchTransmissions(context, payload = {}) {
    const response = await axios.get('/peppol-submissions/pa-report/transmissions', {
      params: params(payload),
    })
    return response.data
  },

  async fetchReconciliation(context, payload = {}) {
    const response = await axios.get('/peppol-submissions/pa-report/reconciliation', {
      params: params(payload),
    })
    return response.data
  },
}
